import * as dateFnsCompat from 'utils/date-fns-compat';

import { dateFormats, pageLayouts } from '../constants';
import { cpdActivityReport } from '../reports';
import { fullName } from '../services';
import { downloadBlobStreamFile, getBlobStream, getPdfStream, unfixedFloor, writeDataToPdfStream } from '../utils';

const exportCpdReportPdf = ({
  afsl,
  cpdActivity,
  filter,
  progress,
  progressTableRows,
  user,
  goals,
  defaultProgressLabel,
  goal
}) => {
  const {
    firstName,
    lastName
  } = user
  const endDate = dateFnsCompat.format(dateFnsCompat.parse(filter.toDate), dateFormats.ShortDate).replace(/\//g, '-')
  downloadBlobStreamFile(writeDataToPdfStream(getPdfStream({
    layout: pageLayouts.landscape,
    size: 'A4'
  }), cpdActivityReport({
    pageLayout: pageLayouts.landscape,
    pageSize: 'A4',
    progressPercentage: unfixedFloor(progress, 1),
    goals,
    defaultProgressLabel,
    reportee: fullName(user),
    afsl,
    minDate: filter.fromDate,
    maxDate: filter.toDate,
    progressTableRows,
    cpdActivity,
    goal
  })).pipe(getBlobStream()), `${firstName}-${lastName}-CPD-activity-${endDate}.pdf`)
}

export default exportCpdReportPdf


// WEBPACK FOOTER //
// ./src/reports/export-cpd-report-pdf.js